<template>
  <div class="container c-plan-form__mobile-layout">
    <div class="row">
      <template v-if="contactSendSuccess">
            <div class="row">
                <FiberContactSuccess
                    :traduction="traduction"
                    />
            </div>
        </template>
        <template v-else>
          <div class="col-12 col">
            <div v-if="isForfait" class="c-plan-form__title">{{ $t('Configure your plan') }} </div>
            <div v-if="isFibre" class="c-plan-form__title">{{ $t('Configure your Fiber offer') }}</div>
            <div v-if="eligibilityStatus && step === 2" class="alert-success d-flex mb-3 align-items-center">
                <span class="alert-icon"><span class="sr-only">Success</span></span>
                <div>
                  <h4 class="alert-heading"> {{ $t('Your address is eligible for')}} {{ getSamIdName }}. {{ $t('Available speed:') }} <strong class="text-primary">{{ samIdOffer.speedValue }} {{ samIdOffer.speedType }}</strong>.</h4>
                </div>
            </div>
            <div class="c-plan-form__container-accordion">
            <div class="c-plan-form__subtitle-container">
              <div class="row">
                <div class="col-sm-8 col-12">
                  <nav role="navigation" class="o-stepbar" aria-label="Checkout process">
                    <ol>
                      <li v-for="(item, i) in stepperItems" :key="i" class="stepbar-item" :class="step === i + 1 ? 'current' : ''">
                        <a v-if="step === i + 1" @click.prevent aria-current="step" class="stepbar-link" href="#" :title="item.title">{{item.label}}</a>
                        <a v-else @click.prevent="setStep(i + 1, true)" class="stepbar-link" href="#" :title="item.title">{{item.label}}</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>

              <!-- <div
                class="u-flex u-flex-align-center u-flex-justify-between"
                role="tab"
                id="PhoneNumber">
                <h5 @click="openPhoneNumber" class="c-plan-form__subtitle">
                  <a class="u-black-text"
                    role="button"
                    aria-expanded="true"
                    aria-controls="collaspePhoneNumber">
                    {{ collaspePhoneNumber }}
                  </a>
                </h5>
                <p
                  v-if="displayModify"
                  @click="openPhoneNumber"
                  class="c-plan-form__subtitle-open">{{ $t('Modify') }}</p>
              </div> -->
              <!-- <div
                ref="collaspePhoneNumber"
                id="0collaspePhoneNumber"
                :class="['collapse', isDev ? 'show' : 'show']"
                role="tabpanel"
                aria-labelledby="PhoneNumber"> -->
              <div v-if="isForfait && eligibilityStatus !== false" class="row">
                <div class="col-12">
                  <keep-alive>
                    <PhoneNumber
                      v-show="step === 1"
                      :data-from-cart="phoneNumberDataFromCart"
                      :traduction="traduction"
                      :plan-data-from-magento="jsonData"
                      v-on:phone-number-next-step="showSecondStep" />
                  </keep-alive>
                </div>
                <div class="c-plan-form__subtitle-container col-12">
                  <SimOptions
                    v-if="step === 2"
                    :data-from-cart="simDataFromCart"
                    :traduction="traduction"
                    :plan-data-from-magento="jsonData"
                    v-on:validate-plan="sendPlan"
                    v-on:set-step="setStep(1)"/>
                </div>
              </div>
            </div>
            <div v-if="isFibre && eligibilityStatus !== false" class="row">
              <FiberPostalCode
                v-show="step === 1"
                :traduction="traduction"
                :plan-data-from-magento="jsonData"
                v-on:next-step="setStep(2)"
                v-on:eligibility-status="getStatus"
              />

              <FiberOptions
                v-show="step === 2"
                :data-from-cart="phoneNumberDataFromCart"
                :traduction="traduction"
                :plan-data-from-magento="jsonData"
                v-on:data-fiber-options-next-step="saveOptionsData"
                v-on:data-phone-number-next-step="savePhoneNumberData"
                v-on:fiber-options-next-step="fiberInstallationStepMethod(fiberInstallationStep)"
              />

              <FiberInstallation
                v-if="step === 3"
                :data-from-cart="simDataFromCart"
                :traduction="traduction"
                :plan-data-from-magento="jsonData"
                v-on:next-step="setStep(3)"
                v-on:validate-plan="sendPlan"
              />

            </div>
            <div class="row" v-if="eligibilityStatus === false">
                <FiberContact
                    :plan-data-from-magento="jsonData"
                    :traduction="traduction"
                    v-on:fiber-contact-submit="getSubmitStatus"
                    />
            </div>
            <!-- <div class="c-plan-form__subtitle-container">
              <div class="" role="tab" id="SimCard">
                  <h5 v-if="additionalStep == 2"
                      @click="openPhoneNumber"
                      class="c-plan-form__subtitle">
                  <a
                    data-parent="#accordionSimCard"
                    role="button"
                    aria-expanded="false"
                    :class="[isFirstStepFilled ? '' : 'u-grey-text- u-pointer-none']"
                    aria-controls="collapseSimCard">
                    {{ collapseSimCard }}
                  </a>
                </h5>
                  <h5 v-else
                      class="c-plan-form__subtitle">
                      <a
                          data-parent="#accordionSimCard"
                          role="button"
                          aria-expanded="false"
                          :class="[isFirstStepFilled ? '' : 'u-grey-text- u-pointer-none']"
                          aria-controls="collapseSimCard">
                          {{ collapseSimCard }}
                      </a>
                  </h5>
              </div>
              <div
                ref="collapseSimCard"
                id="collapseSimCard"
                class="collapse"
                role="tabpanel"
                aria-labelledby="SimCard">

                <SimOptions
                  v-if="step === 2"
                  :data-from-cart="simDataFromCart"
                  :traduction="traduction"
                  :plan-data-from-magento="jsonData"
                  v-on:validate-plan="sendPlan"
                  v-on:set-step="setStep(1)"/>
              </div>
            </div> -->
          </div>
          </div>
        </template>
    </div>
  </div>
</template>

<script>
  import LayoutMixin from '~plans/Mixins/LayoutMixin'

  export default {
    mixins: [LayoutMixin],
    methods: {
        fiberInstallationStepMethod(value) {
            value ? this.setStep(3) : this.sendPlan(this.planDataFromMagento);
        },
      openPhoneNumber () {
        this.displayModify = false
        // jQuery('#collaspePhoneNumber').collapse('toggle')
        // jQuery('#collapseSimCard').collapse('toggle')
      },
      // phoneNumberData comes from the PhoneNumber components after the user had clicked on the
      // next step button
      showSecondStep (phoneNumberData) {
        this.planData.phoneNumber = phoneNumberData

        // jQuery('#collaspePhoneNumber').collapse('toggle')
        // jQuery('#collapseSimCard').collapse('toggle')

        this.isFirstStepFilled = true
        this.displayModify = true
        this.isSecondStepFilled = true
        this.additionalStep = 2
        this.step = this.step + 1
      },
        saveOptionsData(optionsData){
            this.planData.options = optionsData
        },
        savePhoneNumberData(phoneNumberData){
            this.planData.phoneNumber = phoneNumberData
        },
      // simData comes from the sim components after the user had clicked on the
      // next step button
      // showThirdStep (simData) {
      //   this.planData.sim = simData

      //   jQuery('#collaspePhoneNumber').collapse('toggle')
      //   jQuery('#collapseSimCard').collapse('toggle')
      // },
      // options comes from the options components after the user had clicked on the
      // validate plan
      // Here we send the data gathered to magento
      sendPlan (simData) {
        this.planData.sim = simData

        this.$emit('validate-plan', this.planData)
      }
    }
  }
</script>
